import React, { useCallback, useState, useRef } from 'react';

import { ENTER_ESCAPE } from '../../../constants/key-maps';
import {
  analyticsCalculatorRegExp,
  mathSymbolsRegExp,
} from '../../../constants/regular-expressions';
import { MathUtils } from '../../../utils/math-utils';
import HotKeys from '../../hot-keys';
import { isCompliteNumberRegex } from '../is-complite-number-regex';
import { Styled } from './styled';

const useOutSideContainer = () => {
  const refInput = useRef();
  const [isShowOutsideContainer, setShowOutsideContainer] = useState(false);
  const handleMouseDown = useCallback(() => {
    setShowOutsideContainer(true);
  }, []);
  const handleBlure = useCallback(() => {
    setShowOutsideContainer(false);
  }, []);

  const handleBGMousedown = useCallback((e) => {
    refInput.current.blur();
    e.stopPropagation();
    e.preventDefault();
  });

  return [isShowOutsideContainer, handleMouseDown, handleBlure, handleBGMousedown, refInput];
}

export const InputSmall = (props) => {
  const [isShowOutsideContainer, handleMouseDown, handleBlure, handleBGMousedown, refInput] = useOutSideContainer();
  const { input, isInvalid = false, type = 'text' } = props;
  React.useEffect(() => {
    // eslint-disable-next-line @typescript-eslint/no-use-before-define
    setMathString(input.value);
  }, [input.value]);
  const [mathString, setMathString] = useState('');
  const [mathError, setMathError] = useState(false);
  const { disabled, onChange } = input;
  const inputRegExp =
    type === 'text' ? analyticsCalculatorRegExp : mathSymbolsRegExp;
  const onChangeHandler = useCallback(
    (e) => {
      if (!inputRegExp.test(e.target.value)) {
        if (type === 'number' && e.target.value && isCompliteNumberRegex(e.target.value)) {
          const numberValue = Number(e.target.value);
          if (!Number.isNaN(numberValue)) {
            setMathString(MathUtils.round(numberValue, 6).toString());
          } else if (e.target.value === '+' || e.target.value === '-') {
            setMathString(e.target.value);
          }
        } else {
          setMathString(e.target.value);
        }

        setMathError(false);
      }
    },
    [mathString, mathError]
  );
  const onBlurHandler = useCallback(() => {
    handleBlure();
    if (mathString === '') {
      onChange(mathString);
      return;
    }
    try {
      const formattedResult = type === 'text' ? mathString : Number(mathString);
      onChange(formattedResult);
    } catch (e) {
      setMathError(true);
    }
  }, [mathString, mathError]);
  const escHandler = useCallback(() => {
    setMathString(input.value);
    setMathError(false);
  }, [input.value, mathError]);
  return (
    <HotKeys
      keyMap={ENTER_ESCAPE}
      handlers={{ escape: escHandler, enter: onBlurHandler }}
    >
      {isShowOutsideContainer && <Styled.OutSideContainer
        onMouseDown={handleBGMousedown}
      />}
      <Styled.InputContainer
        disabled={disabled}
        error={isInvalid || mathError}
        value={mathString}
        onMouseDown={handleMouseDown}
      >
        <Styled.InputStyle
          onChange={onChangeHandler}
          onBlur={onBlurHandler}
          value={mathString}
          error={isInvalid || mathError}
          isBackground={isShowOutsideContainer}
          ref={refInput}
        />
      </Styled.InputContainer>
    </HotKeys>
  );
};
